import { EndIcon, MicIcon, MicOffIcon } from "./icons";

interface Props {
  live: boolean;
  muted: boolean;
  poweredBy: boolean;
  onToggleMute: () => void;
  onEnd: () => void;
}

export function Controls({ live, muted, poweredBy, onToggleMute, onEnd }: Props) {
  return (
    <div class="wk-controls">
      <div class="row">
        <button class={`wk-ib${muted ? " on" : ""}`} disabled={!live} onClick={onToggleMute} aria-pressed={muted} aria-label={muted ? "Unmute microphone" : "Mute microphone"} title={muted ? "Unmute" : "Mute"}>
          {muted ? <MicOffIcon /> : <MicIcon />}
        </button>
        <button class="wk-ib end" disabled={!live} onClick={onEnd} aria-label="End conversation" title="End">
          <EndIcon />
        </button>
      </div>
      {poweredBy && <span class="wk-foot"><a href="https://workky.cloud" target="_blank" rel="noopener">Powered by Workky</a></span>}
    </div>
  );
}
